import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class VariantsFilter extends kr.Component {
    init() {
        this.app.addEvent('filter_clicked');
        this.app.addEvent('filter_cancel');
        this.bind();

        this.buttons = this.$element.querySelectorAll('.js-variantsFilterButton');
        this.variants = this.$element.querySelectorAll('[data-productid]');
        this.filterEnabled = {};
    }

    bind()
    {
        this.on('click', '[data-filter-value]', (target, event) => {
            event.preventDefault();
            window.dispatchEvent(this.app.getEvent('filter_clicked'));
            const group = target.parentNode.getAttribute('data-filter-group');

            if (HTMLClass.hasClass(target, 'variants__button--active')) {
                delete this.filterEnabled[group];
            } else {
                this.filterEnabled[group] = target.getAttribute('data-filter-value');
            }
            
            this.changeClass();
            this.filter();
        });

        this.app.dom.$window.addEventListener('filter_cancel', () => {
            this.filterEnabled = {};
            this.changeClass();
            this.filter();
        });
    }

    changeClass()
    {
        for (let i in this.buttons) {
            if (!this.buttons.hasOwnProperty(i)) {
                continue;
            }
            HTMLClass.removeClass(this.buttons[i], 'variants__button--active');
        }

        for (let key in this.filterEnabled) {
            const $el = this.$element.querySelector(`[data-filter-group="${key}"] [data-filter-value="${this.filterEnabled[key]}"]`);
            if (!$el) {
                console.warn(`Can't find [data-filter-group="${key}"] [data-filter-value="${this.filterEnabled[key]}"]`);
                continue;
            }
            HTMLClass.addClass($el, 'variants__button--active');
        }
    }

    filter()
    {
        for (let i in this.variants) {
            if (!this.variants.hasOwnProperty(i)) {
                continue;
            }
            if (this.variants[i].style.display != 'none') {
                this.variants[i].oldStyleDisplay = this.variants[i].style.display;
            }

            let display = true;
            for (let key in this.filterEnabled) {
                const attrValue = this.variants[i].getAttribute(`data-filter-${key}`);
                if (attrValue === null || attrValue.indexOf(this.filterEnabled[key]) == -1) {
                    display = false;
                    break;
                }
            }
            if (display) {
                this.variants[i].style.display = this.variants[i].oldStyleDisplay;
            } else {
                this.variants[i].style.display= "none";
            }
        }
    }
}

kr.registerComponent('.js-variantsFilter', {
    component: VariantsFilter
});
